import { render, staticRenderFns } from "./brandSecondType.vue?vue&type=template&id=d1c6d340"
import script from "./brandSecondType.vue?vue&type=script&lang=ts"
export * from "./brandSecondType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports